import axios from 'axios'
import moment from 'moment'
import { NotificationManager } from 'react-notifications'
import {BASE_URL} from '../../constants/Config'
import { AxiosFetchStart, AxiosFetchSuccess, AxiosFetchError } from '../actions/LoadingCenter'
export const APP_GET_VALUES_REQUEST='APP_GET_VALUES_REQUEST'


export const getRequest = (url,params,options = {}) => ({
    type: APP_GET_VALUES_REQUEST,
    payload: {
        
        request: {
            ...options,
            method: 'GET',
            url,
            params,
            
        }
    }
});

export const postRequest = (url,params,data) => ({
    type: APP_GET_VALUES_REQUEST,
    payload: {
        request: {
            method: 'POST',
            url,
            params,
            data: JSON.stringify(data)
        }
    }
});

export const postRequestWithFile = (url,params,data) => ({
    type: APP_GET_VALUES_REQUEST,
    payload: {
        request: {
            method: 'POST',
            url,
            params,
            data: data
        }
    }
});


export const putRequest = (url,params,data) => ({
    type: APP_GET_VALUES_REQUEST,
    payload: {
        request: {
            method: 'PUT',
            url,
            params,
            data: JSON.stringify(data)
        }
    }
});

export const deleteRequest =(url, params) =>({
    type: APP_GET_VALUES_REQUEST,
    payload: {
        request: {
            method: 'DELETE',
            url,
            params
        }
    }
})


export const UpdateTokenRequest=(CallBack) => {
    axios
        .post(`${BASE_URL}/api/users/UpdateToken`,{}, {
            responseType: "application/json",
            headers: {

                'Authorization': 'Bearer ' + localStorage.getItem("token"),
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
            }
        })
        .then((response) => {
            CallBack(response.data);
        })
}



export const GET_HTTP_REQUEST =(Url,Params,CallBack)=>(dispatch)=>{
    dispatch(getRequest(Url,Params))
    .then((resp)=>{
        const {payload:{data,status}}=resp;
        CallBack(data,status);
    })
    .catch((error)=>{
        console.log(error);
    })
}


export const AxiosPDFReport=(url,params,dispatch,CallBack, { throwOnError = false } = {}) => {
    dispatch(AxiosFetchStart())
    try {
        return axios
            .get(`${BASE_URL}/api/${url}`, {
                responseType: "blob",
                headers: {

                    'Authorization': 'Bearer ' + localStorage.getItem("token"),
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
                },
                params
            })
            .then((response) => {
                dispatch(AxiosFetchSuccess())
                if(typeof CallBack==="function"){
                    CallBack();
                }
              
                const pdfWindow = window.open();
                if (!pdfWindow)
                    throw new Error('No se pudo abrir el PDF. Permita las ventanas emergentes y vuelva a imprimir el comprobante.');
                const file = new Blob([response.data], { type: "application/pdf" });
                //Build a URL from the file
                const fileURL = URL.createObjectURL(file);
                //Open the URL on new Window
                pdfWindow.location.href = fileURL;
            })
            .catch((error) => {
                dispatch(AxiosFetchError())
                if (throwOnError) throw error;
                console.log(error);
            });
    } catch (error) {
        dispatch(AxiosFetchError())
        if (throwOnError) return Promise.reject(error);
        return { error };
    }
}

export const AxiosEXCELReport =(url,params,reportName,dispatch, { throwOnError = false } = {})=>{
    dispatch(AxiosFetchStart())
        try {
            return axios
                .get(`${BASE_URL}/api/${url}`, {
                    responseType: "blob",
                    headers: {
    
                        "Authorization": 'Bearer ' + localStorage.getItem("token"),
                        "Content-Type": 'application/json; charset=utf-8',
                        "Access-Control-Allow-Origin": '*',
                        "Access-Control-Allow-Methods": 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
                    },
                    params
                })
                .then((response) => {
                    const contentType = `${(response.headers && response.headers['content-type']) || ''} ${response.data.type || ''}`;
                    if (contentType.toLowerCase().includes('application/pdf')) {
                        throw new Error('La API devolvió un PDF en lugar de Excel. Recompile y reinicie la API e intente nuevamente.');
                    }
                    dispatch(AxiosFetchSuccess())
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', reportName + moment(new Date()).format("YYYY-MM-DD HH:mm:ss") + '.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    dispatch(AxiosFetchError())
                    if (throwOnError) throw error;
                    NotificationManager.error(error.message, 'Exportar Excel');
                    console.log(error);
                });
        } catch (error) {
            dispatch(AxiosFetchError())
            if (throwOnError) return Promise.reject(error);
            NotificationManager.error(error.message, 'Exportar Excel');
            return { error };
        }
}
export const AxiosTXTReport =(url,params,reportName,dispatch)=>{
    dispatch(AxiosFetchStart())
    try {
        axios
            .get(`${BASE_URL}/api/${url}`, {
                responseType: "blob",
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem("token"),
                    "Content-Type": 'application/json; charset=utf-8',
                    "Access-Control-Allow-Origin": '*',
                    "Access-Control-Allow-Methods": 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
                },
                params
            })
            .then((response) => {
                dispatch(AxiosFetchSuccess())
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', reportName /*+ moment(new Date()).format("YYYY-MM-DD HH:mm:ss") */+ '.txt'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => {
                dispatch(AxiosFetchError())
                console.log(error);
            });
    } catch (error) {
        return { error };
    }
}
